import { applicationDetailsReducer, dynamicTableColumnReducer, userApplicationsReducer, userReducer } from "./mobi-office-ui.reducer";

export interface MobiOfficeUIState {
  USER_MASTER: Int_User;
  DYNAMIC_TABLE_COLUMN: Int_DynamicTableColumn;
  APPLICATION_DETAILS: Int_ApplicationDetails;
  USER_APPLICATIONS: Int_UserApplications;
}

export const mobiOfficeUIReducer = {
  USER_MASTER: userReducer,
  DYNAMIC_TABLE_COLUMN: dynamicTableColumnReducer,
  APPLICATION_DETAILS: applicationDetailsReducer,
  USER_APPLICATIONS: userApplicationsReducer,
};

export interface Int_User {
  UserInfo: any;
}

export interface Int_DynamicTableColumn {
  IsLoaded: boolean;
}

export interface Int_ApplicationDetails {
  ApplicationDetails: any;
  IsLoaded: boolean;
}

export interface Int_UserApplications {
  ApplicationsList: any[];
  IsLoaded: boolean;
}
